<div class="quiz-progress" role="status" aria-live="polite">
  <span>QUESTION</span>
  <span class="quiz-progress-numbers">{{ currentQuestion }}/{{ totalQuestions }}</span>
</div>
